  import React, { useState,useRef, useEffect} from "react";
  import { Tooltip  } from "antd";
  import { useQuery } from "react-query";
  import { InfoIcon } from "../common/Icons/InfoIcon";
  import { PelletGoIcon } from "../common/Icons/PelletGoIcon";
  import { CycleDisactiveIcon } from "../common/Icons/CycleDisactiveIcon";
  import { CycleIcon } from "../common/Icons/CycleIcon";
  import { SimpleArrowRight } from "../common/Icons/SimpleArrowRight";
  import _ from "../../i18n";
  import { getTimeSheet,exportPeriodTimeSheet } from "../../api/collaborator";
  import styles from "./TimeSheet.module.scss"; 
  import PageHeader from "../common/PageHeader/PageHeader";
  import { TimeSheetIcon } from "../common/Icons/TimeSheetIcon";
  import { useSelector } from "react-redux";
  import SchemaSidebar from "./TimeSheetSidebar";
  import TimeSheetFilter from "./TimeSheetFilter";
  import { IconExport } from "../common/Icons";
import { getCollaboratorsSuggestions} from "../../api";
import { getErpData } from "../../api/erp";

  const formatHours = (value) => {
    const totalMinutes = Math.floor(value * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, "0")}H${String(minutes).padStart(2, "0")}`;
  };


  const TimeSheet = () => {
    const { token, navCommunity, user ,loggedAs,collaborator } = useSelector(
      (state) => state.auth
    );
    const [timeSheetData, setTimeSheetData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingTable, setLoadingTable] = useState(false); 
    const [error, setError] = useState(null);
    const [expandedNodes, setExpandedNodes] = useState({});
    const [alltypes, setAllTypes] = useState({});
    const [periods, setPeriods] = useState(["2025"]);
    const [nbResult, setNbResult] = useState([]);
    const [filterVisible, setFilterVisible] = useState(false);
    const [lengthData, setLengthData] = useState(0);
    const [collaboratorOptions, setCollaboratorOptions] = useState([]);

    const [showSideBar, setShowSideBar] = useState({
      schemaBar: false,
    });
    const preferences =
      user && navCommunity && user.userOrganizations.length > 0
        ? user.userOrganizations.find(
            (organization) => organization.id === navCommunity.id
          ).authorisation.preferences?.financial
        : {};
    const [filters, setFilters] = useState({
      year: new Date().getFullYear().toString(),
      partner: loggedAs === "PARTNER" ? user.id : null,
      cycles: ["CLIENT", "TASK_TYPE", "COLLABORATOR"],
      clients: [],
      Types: [],
      clientCRMTypes:["CLIENT"],
      keyWord: "",
      periodUnit:"year",
      periods:["2025"],
      collaborators: [],
      deletedStatus: "NOT_DELETED",
      clientGroups: [],
      clientCRMGroup: [
        "Sociétés",
        "Indépendants",
        "Partenaire",
        "Particuliers",
        "Gérants",
        "Sociétés - Partenaire",
        "ASBL",
        "Indépendants petite entreprise",
        "AiSBL",
        "ASBL - Consultation",
        "Particuliers - Consultation",
        "Contact",
        "Gérant petite entreprise",
        "Indépendants - Consultation",
        "ASBL - Partenaire",
        "ASBL petite entreprise",
        "Fondation privée",
        "Sociétés petite entreprise",
      ],}); 

      const TreeRow = ({ node, level, expandedNodes, toggleNode, period, periodUnit }) => {
      const isExpandable = node.children && node.children.length > 0;
      const isExpanded = expandedNodes[node.data.id];

      return (
        <>
        <div>
        <div
          className={`${styles.treeRow}`}
        >
          <div 
            style={{ flexBasis:'350px'}}
            className={`
              ${styles.cell}
            
              ${node.data.label !== "TOTAL" ? styles[`level-${level}`] : ""}
              ${isExpandable ? styles.withChildren : styles.withoutChildren}
              ${node.data.label === "TOTAL" ? styles.totalRow : ""}
            `}
          >

              {isExpandable && (
                <span
                  onClick={() => toggleNode(node.data.id)}
                  className={styles.toggleButton}
                >
                  {isExpanded ? "-" : "+"}
                </span>
              )}
            <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%", 
                }}
              >
          <span style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            marginLeft: "-10px",
            ...(node.data.level === "level-3" && {
              cursor: "default",
              WebkitTransition: "all 0.5s",
              OTransition: "all 0.5s",
              transition: "all 0.5s",
              overflow: "hidden",
            }),
          }}>
            {node.data.label}
        
            {["COLLABORATOR", "RESPONSIBLE", "DELEGATED", "CLIENT"].includes(node.data.type) && (
              <>
             
              <Tooltip
                  key="tool-2"
                  placement="top"
                 
                  title={
                    (() => {
                     
                
                      const client = erpDataQuery.data?.data?.clients?.find(client =>
                        Object.keys(client)[0] === String(node.data.id)
                        
                      );
                    
                      const collaborator = erpDataQuery.data?.data?.collaborators?.find(collab =>
                        Object.keys(collab)[0] === String(node.data.id)
                      );
                
                      let content = "";
                      if (node.data.type === "CLIENT" && client) {
                        const clientData = client[node.data.id];
                        content = `${_("importedFrom")}:${clientData.erpLabel ?? ""}\n${_("identifier")}: ${clientData.erpId}`;
                      } else if (node.data.type === "COLLABORATOR" && collaborator) {
                        const collaboratorData = collaborator[node.data.id];
                        content = `${_("importedFrom")}: ${collaboratorData.erpLabel ?? ""}\n${_("identifier")}: ${collaboratorData.erpId}`;
                      }
                    
                      return content ;
                    })()
                  }
                >
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                  >
                    <InfoIcon fill="#29394D" size={12} className={styles.InfoIcon} />
                  </span>
                </Tooltip>
              </>
            )}
            </span>
      
          {["COLLABORATOR", "RESPONSIBLE", "DELEGATED", "CLIENT"].includes(node.data.type) && (
            <div className="open-button" style={{ display: "inline-flex", alignItems: "center" }}>
              <span onClick={() => handlePelletGoClick(node)} 
                  style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", marginRight: "40px" }}>
                <PelletGoIcon fill="#29394D" size={12} className={styles.PelletGoIcon} />
              </span>
            </div>
          )}
        </span>
    
    
          </div>
          {filters.periodUnit !== "year" ? (
              <>
              {periods.map((p) => (
               <div
               key={p}
               className={`${styles.cell} ${
                 node.data.label === "TOTAL"
                   ? styles.totalRow
                   : styles.clientRow
               }  ${[3, 4].includes(level) ? styles["level-" + level] : ""}`}
               style={{
                 justifyContent: "center",
               }}
             >
             
                <div className={styles.cell_value}>
                  {node.data[p]?.value ? formatHours(node.data[p].value) : "00H00"}
                </div>
                </div>
              ))}


           </>
            ) : (
              <div
                className={`${styles.cell} ${
                  node.data.label === "TOTAL"
                    ? styles.totalRow
                    : styles.restRow
                }  ${[3, 4].includes(level) ? styles["level-" + level] : ""}`}
                style={{
                  justifyContent: "center",
                }}
              >

                {node.data[period]?.value
                  ? formatHours(node.data[period].value)
                  : "00H00"}
              </div>
              
            )}

        </div>
      </div>
          {isExpanded &&
            node.children?.map((child) => (
              <TreeRow
                key={child.data.id}
                node={child}
                level={level + 1}
                expandedNodes={expandedNodes}
                toggleNode={toggleNode}
                period={period}
              />
            ))}
        </>
      );
    };
    const expandAllChildren = (node, expanded = {}) => {
      expanded[node.data.id] = true;
      if (node.children && node.children.length > 0) {
        node.children.forEach(child => expandAllChildren(child, expanded));
      }
      return expanded;
    };
    const handlePelletGoClick = (node) => {
      if (node.data.type === "CLIENT") {
        setFilters({
          ...filters,
          clients: [node.data.id],
        });
      } else if (["COLLABORATOR", "RESPONSIBLE", "DELEGATED"].includes(node.data.type)) {
        setFilters((prev) => ({ ...prev, collaborators: [node.data.id] }));
      }
    
      const expanded = expandAllChildren(node);
      setExpandedNodes(prev => ({ ...prev, ...expanded }));
    };
    

    const erpDataQuery = useQuery(
      ["getErpData", token, navCommunity?.id],
      async () => {
        if (!token || !navCommunity?.id) {
          return null;
        }
    
        try {
          const response = await getErpData(token, navCommunity.id);
          return response.data;
        } catch (e) {
          console.error("Error fetching ERP data:", e);
          return null;
        }
      },
      {
        enabled: !!token && !!navCommunity?.id,
      }
    );
    
    let collaboratorsdQuery = useQuery(
     
      ["getCollaborators", token, navCommunity, filters.partner],
      async () => {
        if (token && navCommunity) {
          const partner = filters.partner;
    
          try {
            const response = await getCollaboratorsSuggestions(
              token,
              navCommunity.id
            );
            let data = response.data.data;
    
            if (partner && partner !== 0) {
              data = data.filter((item) => item !== null && item.partner?.value === partner);
            }
    
            data = data.map((t) => ({
              value: t.id,
              label: t.name,
              partner: t?.partner?.value,
              erpId: t?.erpId,       
              erpLabel: t?.erpLabel, 
            }));
    
            setCollaboratorOptions(data);
          } catch (e) {
            console.error("Error fetching collaborators:", e);
            return null;
          }
        }
      },
      {
      }
    );
    useEffect(() => {

      const fetchData = async () => {
        setLoadingTable(true);
        try {
          const result = await getTimeSheet(
            token,
            navCommunity.id,
            filters.partner,
            filters.cycles,                              
            filters.clients,
            filters.clientGroups,
            filters.collaborators,         
            filters.Types,            
            filters.periodUnit,
            filters.periods,             
            filters.keyWord,          
            filters.clientCRMTypes,
            filters.clientCRMGroup,
            filters.deletedStatus,
          );
    
          if (result.data && result.data.data && result.data.data.timeSheet) {
            setTimeSheetData(result.data.data.timeSheet || []);
          } else {
            setTimeSheetData([]); 
          }
    
          const extractTypes = (data) => {
            const types = new Set();
          
            const traverse = (nodes) => {
              for (const node of nodes) {
                const type = node.data?.type;
                if (type && type !== "TOTAL") {
                  types.add(type);
                }
                if (node.children && node.children.length > 0) {
                  traverse(node.children);
                }
              }
            };
          
            traverse(data);
            return Array.from(types);
          };
          
          
          const allTypes = extractTypes(result.data.data.timeSheet || []);
          setAllTypes(allTypes);


          setPeriods(result.data.data.periods || []);
    
        } catch (err) {
          setError(err.message || "Erreur inconnue");
          setTimeSheetData([]); 
        } finally {
          setLoading(false);
          setLoadingTable(false);
        }
      };

      fetchData();
    }, [filters]); 


    const toggleNode = (id) => {
      setExpandedNodes((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    };

    if (loading) {
      return (
        <div className="ripple_loading">
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
        </div>
      );
    }
    const handleChangeYear = (year) => {
      setFilters({
        ...filters,
        year: year,
      });
    };
    const handleFilterChange = (newFilters) => {
      setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    };
    const handleExportTimeSheet = async () => {
      try {
        await exportPeriodTimeSheet(
          token,
          navCommunity.id,
          filters.cycles,
          filters.clients,           
          filters.clientGroups,      
          [],                       
          filters.clientTypes,      
          filters.periodUnit,
          [filters.year],           
          filters.searchWord,        
          ["CLIENT"],                
          filters.clientCRMGroup,    
          false                     
        );
      } catch (err) {
        console.error("Erreur lors de l'export :", err);
      }
    };
    
    const renderAddBubble = () => {
      return (
        <div className="setting-bubbles">
          <div
            className={`circleSvg`}
            style={{ height: 50, cursor: "pointer" }}
            onClick={() =>
              setShowSideBar((prev) => ({
                ...prev,
                schemaBar: !prev.schemaBar,
              }))
            }
          >
            <CycleDisactiveIcon size="20" fill="#6D7F92" />
            <span style={{ paddingLeft: "2.5rem" }}>{_("Schéma")}</span>
          </div>
        </div>
      );
    };
    const  renderCycleGuide = () => {
      
      return (
        <div
          className={styles.cycle}
          style={{ position: "relative", marginLeft: "20px" }}
        >
          <div
            className={styles.label}
            onClick={() =>
              setShowSideBar((prev) => ({
                ...prev,
                schemaBar: !prev.schemaBar,
              }))
            }
          >
            <CycleIcon />  <span>{_("cycleLabel")} : </span> 
          </div>
            {filters.cycles.map((key, idx) => (
              <div className={styles.cellule} key={idx}>
              <span>{_(key)}  <SimpleArrowRight /> </span>
              
            </div>
             
              ))}
         
        
        </div>
      );
    };
  
    

    const renderFilter = () => (
      <TimeSheetFilter
      token={token}
      navCommunity={navCommunity}
      lengthData={lengthData}
      pageSize={filters.pageSize}
      setFilters={setFilters}
      selectedYear={filters.year}
      customAddOn={renderCycleGuide()}
      filterFormIsVisible={false}
      filters={filters}
      resetFilter={handlePelletGoClick}
      collaborator={collaborator}
      filterVisible={filterVisible}
      preferences={preferences}
      nbResult={nbResult}

      />
    );
    return (
      <div className="page-content">
        <PageHeader
          header={_("Presta-ts")}
          subHeader={_("subTitleTimeSheet")}
          icon={<TimeSheetIcon size="36" fill="#29394D" />}      
        >
        <div
              className={styles.forfait__export_btn}
              onClick={handleExportTimeSheet}   
            >  <IconExport size={20} />
                  Exporter   
            </div>
          </PageHeader>
      {renderAddBubble()}
      
        {showSideBar.schemaBar && (
      <SchemaSidebar
      onClose={() => setShowSideBar({ schemaBar: false })}
      allTypes={filters.cycles}
      onSave={(updatedItems) => {
        const newCycles = updatedItems
          .filter((item) => item.visible)
          .map((item) => item.content);

        setFilters((prev) => ({ ...prev, cycles: newCycles }));
        setShowSideBar({ schemaBar: false }); 
      }}
    />

    )}

<div className={styles.timeSheet}>
  {renderFilter()}
  <div style={{
        overflow: 'scroll',
        position: 'relative',
  }}>
    {timeSheetData && timeSheetData.length > 0 && !loadingTable && (

      <div className={styles.timeSheetHeader}>
        <div style={{ flexBasis:'387px'}}
        className={styles.headerCell}>NOM</div>

        {filters.periodUnit !== "year" && filters.periodUnit !== "date" ? (
          <>
            {filters.periods.length > 1 && (
              <div style={{ flexBasis:'38px'}} className={styles.headerCell}>SOMME</div>
            )}

            {filters.periods.map((period, index) => (
              <div style={{ flexBasis:'37px'}}    key={index} className={styles.headerCell}>
                {period}
              </div>
            ))}
          </>
        ) : (
          
          <div style={{ flexBasis:'36px'}} className={styles.headerCell}>{filters.periods}</div>
        )}
      </div>

    )}

    {  loadingTable ? (
            <div className="ripple_loading">
              <img src={"/img/Ripple-1s-150px.svg"} alt="Loading" />
            </div>
          ) : (
            <div className={styles.timeSheetBody}>
              {timeSheetData && timeSheetData.length > 0 ? (
                <div className={styles.treeContainer}>
                  {timeSheetData.map((node) => (
                    <TreeRow
                    key={node.data.id}
                    node={node}
                    level={0}
                    expandedNodes={expandedNodes}
                    toggleNode={toggleNode}
                    period={filters.periods}
                    periodUnit={filters.periodUnit} 
                  />
                  ))}
                </div>
              ) : (
                <div className="no_data">
                <div className="title">{_("noDataFound")}</div>
                <div className="subTitle">{_("noTimeSheet")}</div>
              </div>
              )}
            </div>
          )}
  </div>

</div>

      </div>
    );
  };

  export default TimeSheet;